const DATA_TEST_KEYS = {
    TYPE: "data-test-type",
    NAME: "data-test-name",
    ID: "data-test-id"
};

export { DATA_TEST_KEYS };
//# sourceMappingURL=constants.js.map
